
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  props: {
    /** 是否可交互 */
    clickable: { type: Boolean, default: false },
    /** 分数 */
    score: { type: Number, default: undefined },
    /** 星星底部文案 */
    hint: {
      type: Array as PropType<string[]>,
      default: undefined,
    },
    /** 尺寸 */
    size: { type: [String, Number], default: 12 },
    /** 间距 */
    spacing: { type: [String, Number], default: 2 },
    /** v-model */
    modelValue: { type: Number, default: undefined },
  },
  emits: ['change', 'update:modelValue'],
  computed: {
    scoreInt(): number {
      return Math.round(this.score || this.modelValue || 0);
    },
  },
  methods: {
    /** 点击星星触发 change 事件 */
    handleClickStar(i: number) {
      if (this.clickable) {
        this.$emit('change', i);
        this.$emit('update:modelValue', i);
      }
    },
  },
});
